import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { Icon, Label, Modal } from 'semantic-ui-react';
import { Container, Grid } from '@mui/material';
import { IDataService, DataService, Helper, IHelper} from '../../services';
import styles from './OpenLinkedDocuments.module.scss';
import {IDocumentHistory, IRelatedDocuments} from '../../intefaces';

interface IOpenLinkedDocumentProps {
    relatedDocs: string[];
    searchText: string;
    docId: string;
    title: string;
}
interface IOpenLinkedDocumentState {
    isMenuOpen: boolean;
    isLoading: boolean;
    relatedDocs: IRelatedDocuments[];
    redirect: boolean;
    searchQuery: string;
    docsCount: number;
    openModal: boolean;
}

export class OpenLinkedDocument extends React.Component<IOpenLinkedDocumentProps, IOpenLinkedDocumentState> {
    private _dataService: IDataService = new DataService();
    private _helpers: IHelper = new Helper();

    constructor(props: IOpenLinkedDocumentProps) {
        super(props);
        this.state = {
            isMenuOpen: false,
            isLoading: true,
            relatedDocs: [],
            redirect: false,
            searchQuery: '',
            docsCount: 0,
            openModal: false
        }

    }

    async componentDidMount() {
        await this.callApi().then(() => {
            this.setState({ isLoading: false });
        });
    }

    public render() {
        const txt = `${this.state.relatedDocs.length > 0 ? (this.state.relatedDocs.length > 0 ? this.state.relatedDocs.length + ' Linked Document(s)' : '0 Linked Document(s)') : (this.state.isLoading ? 'Loading...' : '0 Linked Document(s)')}`;
        return (
            <>
                {this.state.redirect ? <Redirect to={this.state.searchQuery} /> : <div />}
                <Icon name='linkify' />
                <Modal
                    open={this.state.openModal}
                    onOpen={() => this.setState({ openModal: true })}
                    onClose={() => this.setState({ openModal: false })}
                    trigger={<label className={styles.label}>{txt}</label>} 
                    closeIcon={true}
                >
                    <Modal.Header>Related documents</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            {this.getData()}
                        </Modal.Description>
                    </Modal.Content>
                </Modal>
            </>
        );
    }

    private getData() {
        return this.state.relatedDocs.length > 0 ? (this.state.relatedDocs.map((e, i) => {
            return (
                <Container key={i} className={styles.relatedDocs} onClick={() => this.onClick(e.id)}>
                    <Grid container className={styles.grid}>
                        <Grid item xs={8}>
                            <div className={styles.tag}>{e.division}</div>
                            <div className={styles.title}>{this._helpers.ShowAllTitles(e.title)}</div>
                            <div className={styles.author}>{e.author}</div>
                            <div className={styles.docTags}>
                                {e.documentType.length > 0 ? this.generateDocTagsFlat(e.documentType) : <></>}
                            </div>
                            <div className={styles.fileName}>{e.fileName}</div>
                        </Grid>
                        <Grid item xs={4} className={styles.middle}>
                            <div className={styles.date}>{this._helpers.FormatDate(e.contractDate)}</div>
                            {e.confidential ? <div className={styles.reversion}>Confidential</div> : <></>}
                        </Grid>
                    </Grid>
                </Container>

            );
        })) : <div>Error</div>
    }

    private generateDocTagsFlat(docs: any) {
        return docs.map((doc: any, index: any) => {
            return <Label key={index} className={styles.docTag}>{doc}</Label>;
        });
    }

    private onClick(d: any) {
        let searchQuery = `/documentView?q=${this.props.searchText}&id=${d}`;
        let documentHistory: IDocumentHistory = { documentTitle: this.props.title[0], documentUrl: `${window.location.origin}${searchQuery}` };
        this._dataService.CallUpdateDocumentHistory(documentHistory);
        this.setState({
            searchQuery: searchQuery,
            redirect: true
        });
    }

    private async callApi() {
        try {
            let results: IRelatedDocuments[] = [];

            await this._dataService.CallRelatedDocumentsApi(this.props.relatedDocs).then((e) => {

                e[0].relatedDocsIndexDocument.map((value: any, index: any) => {
                    if (this.props.docId != value.id) {
                        results.push(value);
                    }
                })
            }).then(() => {
                this.setState({
                    relatedDocs: results
                });
            });
        } catch (e) {
            return 'Error';
        }
    }
}